<template>
  <div class="quest" @click="loadQuest" :class="[styleType, interactable? 'pointer' : '']">
    <div class="icon-container d-flex align-items-center justify-content-center"
         :class="questTypeClassBackground(quest.type)">
      <div class="completed-indicator" v-if="quest?.usedByActivity">
        <CheckLogo/>
      </div>
      <SymbolIcon :iconName="quest.type" :color="'white'" :hoverName="PrettyName[quest.type]"></SymbolIcon>

    </div>
    <div class="title">
      <ClockIcon v-if="quest.isPlanned" class="clock-icon mr-1"/>
      <span>
        <span class="mr-1" v-if="titlePrefix !== ''">{{ titlePrefix }}</span>{{ quest.title }}
      </span>
    </div>
    <div class="score d-flex align-items-center justify-content-center">
      <span @click="toggleFavourite"><FavouriteIconEmpty v-if="!faved"
                                                         class="favourite-icon favourite-icon-empty mr-3"
                                                         v-hover="onHoverOverFavouriteButton"/>
              <FavouriteIconFilled v-if="faved" class="favourite-icon  mr-3" v-hover="onHoverOverFavouriteRemoveButton"/></span>
      {{ quest.points }}&nbsp;<BatteryLogo v-if="!hideStar" class="energy-icon mr-3"/>
      <NewActivityIcon v-if="recentActivity" :show="true" :color="'red'"></NewActivityIcon>

      <HoverInfo :show="hoveringOverFavouriteButton" :content="'Markeer als favoriet'" :offset-y="12" :offset-x="12"></HoverInfo>
      <HoverInfo :show="hoveringOverFavouriteRemoveButton" :content="'Verwijder als favoriet'" :offset-y="12" :offset-x="12"></HoverInfo>

    </div>
  </div>
</template>

<script>
import QuestTypeHelper from "@/mixins/QuestTypeHelper";
import DateFormatter from "@/mixins/DateFormatter";

import BatteryLogo from "@/assets/image/icons/quest/icon-activity_points.svg?inline";
import ClockIcon from "@/assets/image/icons/publication-status/icon-status_planned.svg?inline";

import CheckLogo from "@/assets/image/icons/icon-check.svg?inline";
import FavouriteIconEmpty from "@/assets/image/icons/icon_favourite_NEW.svg?inline";
import FavouriteIconFilled from "@/assets/image/icons/icon_favouriteclicked_NEW.svg?inline";
import { QuestFormatEnum } from "sandpiper_api";
import SymbolIcon from "@/components/UI/SymbolIcon.vue";
import {PrettyName} from "@/enums/PrettyName";
import NewActivityIcon from "@/components/UI/NewActivityIcon.vue";
import HoverInfo from "@/components/UI/HoverInfo.vue";

export default {
  name: "QuestSmall",
  components: {
    HoverInfo,
    NewActivityIcon,
    SymbolIcon,
    BatteryLogo,
    ClockIcon,
    CheckLogo,
    FavouriteIconEmpty,
    FavouriteIconFilled,
  },
  props: {
    quest: Object,
    styleType: String,
    hideStar: Boolean,
    interactable: Boolean,
  },
  mixins: [ QuestTypeHelper, DateFormatter ],
  emits: [ "clicked" ],
  data()
  {
    return {
      questFormatEnum: new QuestFormatEnum(),
      hoveringOverFavouriteButton: false,
      hoveringOverFavouriteRemoveButton: false,
      faved: false,
    }
  },
  computed: {
    PrettyName() {
      return PrettyName
    },
    questType()
    {
      return this.quest.type;
    },
    titlePrefix()
    {
      switch (this.quest.format)
      {
        case this.questFormatEnum.quiz:
          return "[Quiz]"
        case this.questFormatEnum.puzzle:
          return "[Puzzel]"
        default:
          return "";
      }
    },
    recentActivity() {
      let date = this.quest.publicationStatus.lastPublicationDate;
      if (!date) return false;

      const oneWeekMs = 7 * 24 * 60 * 60 * 1000;
      return date.getTime() > Date.now() - oneWeekMs;
    }
  },
  methods: {
    loadQuest()
    {
      if (this.interactable)
      {
        if (this.styleType === 'student-platform')
        {
          this.$emit("clicked", this.quest.id);
        }
        else
        {
          this.$router.push({
            name: 'quest-detailed', params: {
              id: this.quest.id
            }
          });
        }
      }
    },
    checkFavourited()
    {
      let savedFaves = localStorage.getItem("BBUDfavourites");

      if (!savedFaves || !JSON.parse(savedFaves).includes(this.quest.id))
      {
        this.faved = false;
      }
      else
      {
        this.faved = true;
      }
    },
    toggleFavourite(e)
    {
      e.preventDefault();
      e.stopPropagation();

      let faves = JSON.parse(localStorage.getItem("BBUDfavourites"));
      if (!faves)
      {
        faves = [];
        faves.push(this.quest.id);
        this.faved = true;
      }
      else if (!faves.includes(this.quest.id))
      {
        faves.push(this.quest.id);
        this.faved = true;
      }
      else
      {
        faves.splice(faves.indexOf(this.quest.id), 1);
        this.faved = false;
      }

      localStorage.setItem("BBUDfavourites", JSON.stringify(faves));

    },
    onHoverOverFavouriteButton(state) {
      this.hoveringOverFavouriteButton = state;
      this.hoveringOverFavouriteRemoveButton = false;
    },
    onHoverOverFavouriteRemoveButton(state) {
      this.hoveringOverFavouriteRemoveButton = state;
      this.hoveringOverFavouriteButton = false;
    },
  },
  mounted()
  {
    this.checkFavourited();
  }
}
</script>

<style lang="scss" scoped>
.quest
{
  background-color: white;
  border-radius: 5px;
  box-shadow: $default-shadow;
  margin-bottom: 0.66rem;

  display: flex;

  height: 50px;

  .icon-container
  {
    position: relative;

    min-width: 50px;

    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;

    overflow: visible;

    > svg
    {
      fill: $font-light;
    }
  }

  .completed-indicator
  {
    position: absolute;
    top: 0;
    left: 0;
    width: 50%;
    height: 50%;
    padding: 2px 0 0 2px;

    &::before
    {
      content: "";

      position: absolute;
      top: 0;
      left: 0;

      border: 12.5px solid $primary-blue;
      border-right-color: transparent;
      border-bottom-color: transparent;
    }

    svg
    {
      position: absolute;
      top: 2px;
      left: 2px;
      width: 11px;
      height: 11px;

      fill: $font-light;
    }
  }

  .title
  {
    padding: 10px;
    flex: 1 1;

    display: flex;
    flex-direction: row;

    justify-content: flex-start;
    align-items: center;

    font-size: 0.875rem;
    font-weight: 500;

    min-width: 0; // To make the ellipsis work https://css-tricks.com/flexbox-truncated-text/

    span
    {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-right: 5px;
    }

    .timestamp
    {
      overflow: inherit;
      color: $primary-blue;
      font-style: italic;
      font-weight: 400;
    }
  }

  .score
  {
    font-weight: 500;
    //margin-right: 15px;
  }

  .no-star .fa-star
  {
    display: none;
  }

  //for use in student platform activity list
  &.student-platform
  {
    background-color: #082B42;
    color: white;

    .icon-container {
      display: none !important;
    }

    .energy-icon {
      fill: white;
    }

    .favourite-icon {
      fill: white;
    }
  }
}

.pointer {
  cursor: pointer;
}

.quest .favourite-icon-empty {
  display: none;
}

.quest:hover {
  .favourite-icon-empty {
    display: block;
  }
}
</style>